module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAJNJREFUOE/l0qENAkEQheHvasDhqQIqQJ3EUAAJCkeQCNwpOkDhUFQAoQk0jh7IJgNicwshJ2/s5v3z9s9UOk7VMa8HgHU42pVcfXOwRB3BE/ZtkBJgjhXGEbqiwSGHtAHS1lR5gmcEBrggfSm1+UwOmEbVFH5k24a4YYHz+y0HHLHBvSBthC1mJcDfh9mDS/zp5AVFhBERzdN8BAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios-arrow-up.png
// module id = 2623
// module chunks = 2